<template>
    <div>
        <vs-card style="min-height: 100px">
            <vs-row>
                <vs-col vs-justify="center" vs-align="center" vs-w="6" vs-xs="12" class="p-2">
                    <div class="flex mb-1">
                        <label for="">{{ $t('entity') | capitalize }}</label>
                    </div>
                    <v-select :options="entities" :reduce="(el) => el.id" label="name" v-model="filter.entity"
                        class="w-full" @input="getData()" />
                </vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="2" vs-xs="12" class="p-2">
                    <div class="flex mb-1">
                        <label for="">{{ $t('year') | capitalize }}</label>
                    </div>
                    <v-select :options="years" label="year" v-model="filter.year" class="w-full" @input="getData()" />
                </vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="2" vs-xs="12" class="p-2">
                    <div class="flex mb-1">
                        <label for="">{{ $t('month') | capitalize }}</label>
                    </div>
                    <v-select :options="months" :reduce="(el) => el.id"
                        :label="$i18n.locale === 'es' ? 'label_es' : 'label_en'" v-model="filter.month" class="w-full"
                        @input="getData()" />
                </vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="2" vs-xs="12" class="p-2">
                    <div class="flex mb-1">
                        <label for="">{{ $t('currency') | capitalize }}</label>
                    </div>
                    <v-select :options="currencies" :reduce="(el) => el.id" label="label" v-model="filter.currency"
                        class="w-full" @input="getData()" />
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col vs-justify="center" vs-align="center" vs-w="12" vs-xs="12" class="p-2">
                    <div class="flex mb-1">
                        <label for="">{{ $t('departament') | capitalize }}</label>
                    </div>
                    <v-select :options="departaments" :reduce="(el) => el.id" label="name" v-model="filter.departament"
                        class="w-full" multiple @input="getData()" />
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col vs-justify="center" vs-align="center" vs-w="12" vs-xs="12" class="p-2">
                    <div class="flex mb-1">
                        <label for="">{{ $t('category') | capitalize }}</label>
                    </div>
                    <v-select :options="categories" :reduce="(el) => el.id" label="name" v-model="filter.category"
                        class="w-full" multiple @input="getData()" />
                </vs-col>
            </vs-row>
        </vs-card>

        <vs-row>
            <vs-col vs-justify="center" vs-align="center" vs-w="12">
                <BudgetCategoryTable :data="budget.filtered" :totals="budget.totals" :month="month"
                    :loading="loading.data" :period="budget.period" @search="search" />
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import loading from '@/mixins/Loading'
import vSelect from 'vue-select'
import request from './request.js'
import BudgetCategoryTable from './components/BudgetCategoryTable.vue'

export default {
    components: {
        'v-select': vSelect,
        BudgetCategoryTable,
    },
    data() {
        return {
            entities: [{ id: '0', name: 'All' }],
            departaments: [{ id: '0', name: 'All' }],
            categories: [{ id: '0', name: 'All' }],
            years: [],
            months: [
                { id: '1', label_en: 'January', label_es: 'Enero' },
                { id: '2', label_en: 'February', label_es: 'Febrero' },
                { id: '3', label_en: 'March', label_es: 'Marzo' },
                { id: '4', label_en: 'April', label_es: 'Abril' },
                { id: '5', label_en: 'May', label_es: 'Mayo' },
                { id: '6', label_en: 'June', label_es: 'Junio' },
                { id: '7', label_en: 'July', label_es: 'Julio' },
                { id: '8', label_en: 'August', label_es: 'Agosto' },
                { id: '9', label_en: 'September', label_es: 'Septiembre' },
                { id: '10', label_en: 'October', label_es: 'Octubre' },
                { id: '11', label_en: 'November', label_es: 'Noviembre' },
                { id: '12', label_en: 'December', label_es: 'Diciembre' },
            ],
            currencies: [
                { id: 'usd', label: 'USD' },
                { id: 'mxn', label: 'MXN' },
                { id: 'usd_est', label: 'USD EST' }
            ],
            filter: {
                year: null,
                entity: null,
                departament: null,
                month: null,
                currency: null,
                category: null,
            },
            budget: {
                data: [],
                filtered: [],
                totals: {
                    expense_total_month: 0,
                    expense_accumulated: 0,
                    budget_total_month: 0,
                    budget_accumulated: 0,
                    variation_month: 0,
                    variation_porcentage_month: 0,
                    variation_accumulated: 0,
                    variation_porcentage_accumulated: 0,
                    utilization_month: 0,
                    utilization_accumulated: 0
                },
                period: {
                    weeks_no_month: 0,
                    week_no_year: 0,
                    total_weeks_month: 0,
                    total_weeks_year: 0,
                    utilization_month: 0,
                    utilization_accumulated: 0
                },
            },
            loading: {
                data: false,
                entities: false,
                departaments: false,
                years: false,
                categories:false
            },
            month: '',
            loadingPage: 'budget-entity-loading',
        }
    },
    methods: {
        getEntities() {
            this.loading.entities = true
            request
                .getEntities()
                .then((response) => {
                    this.entities = [...this.entities, ...response.data]
                    this.loading.entities = false
                })
                .catch((error) => {
                    this.loading.entities = false
                    this.showValidationErrors(error)
                })
        },
        getDepartaments() {
            this.loading.departaments = true
            request
                .getDepartaments()
                .then((response) => {
                    this.departaments = [...this.departaments, ...response.data]
                    this.loading.departaments = false
                })
                .catch((error) => {
                    this.loading.departaments = false
                    this.showValidationErrors(error)
                })
        },
        getCategories() {
            this.loading.catetories = true
            request
                .getCategories()
                .then((response) => {
                    this.categories = [...this.categories, ...response.data]
                    this.loading.catetories = false
                })
                .catch((error) => {
                    this.loading.catetories = false
                    this.showValidationErrors(error)
                })
        },
        getYears() {
            this.loading.years = true
            request
                .getYears()
                .then((response) => {
                    this.years = response.data.map(function (obj) {
                        return obj.year
                    })

                    this.loading.years = false
                })
                .catch((error) => {
                    this.loading.years = false
                    this.showValidationErrors(error)
                })
        },
        getData() {

            if (
                this.filter.year == null ||
                this.filter.entity == null ||
                this.filter.departament == null ||
                this.filter.departament.length == 0 ||
                this.filter.category == null ||
                this.filter.category.length == 0 ||
                this.filter.month == null ||
                this.filter.currency == null
            ) {
                return
            }

            this.setMonth()
            this.loading.data = true
            const payload = {
                year: this.filter.year,
                entity: this.filter.entity,
                departament: this.filter.departament,
                category: this.filter.category,
                month: this.filter.month,
                currency: this.filter.currency,
            }
            request
                .list(payload)
                .then((response) => {
                    let data = [...response.data.budgets]
                    let expenses = [...response.data.expenses]
                    this.budget.period = { ...response.data.period }
                    data.forEach(el => {
                        el.expenses = expenses.filter((expense) => expense.category_id == el.category_id);
                        el.utilization_month = this.getPercentage(el.expense_total_month, el.budget_total_month)
                        el.utilization_accumulated = this.getPercentage(el.expense_accumulated, el.budget_accumulated)
                        el.show = false
                    });
                    this.budget.data = [...data]
                    this.budget.filtered = [...data]
                    this.getTotals()
                    this.loading.data = false
                })
                .catch((error) => {
                    this.loading.data = false
                    console.log(error)
                })

        },
        setMonth() {
            const month = this.months.find((el) => el.id == this.filter.month)
            this.month = this.$i18n.locale === 'es' ? month.label_es : month.label_en
        },
        getTotalColumn(column) {
            return this.budget.filtered.reduce((a, c) => Number(a) + Number(c[column]), 0)
        },
        getPercentage(value1, value2) {
            const x = Number(value1);
            const y = Number(value2);
            if (x == '0' || y == '0') {
                return 0;
            }
            return (value1 / value2) * 100;
        },
        getTotals() {
            this.budget.totals.expense_total_month = this.getTotalColumn('expense_total_month');
            this.budget.totals.expense_accumulated = this.getTotalColumn('expense_accumulated');
            this.budget.totals.budget_total_month = this.getTotalColumn('budget_total_month');
            this.budget.totals.budget_accumulated = this.getTotalColumn('budget_accumulated');
            this.budget.totals.variation_month = this.getTotalColumn('variation_month');
            this.budget.totals.variation_porcentage_month = this.getPercentage(this.budget.totals.variation_month, this.budget.totals.budget_total_month);
            this.budget.totals.variation_accumulated = this.getTotalColumn('variation_accumulated');
            this.budget.totals.variation_porcentage_accumulated = this.getPercentage(this.budget.totals.variation_accumulated, this.budget.totals.budget_accumulated);
            this.budget.totals.utilization_month = this.getPercentage(this.budget.totals.expense_total_month, this.budget.totals.budget_total_month);
            this.budget.totals.utilization_accumulated = this.getPercentage(this.budget.totals.expense_accumulated, this.budget.totals.budget_accumulated);
        },
        search(text) {
            this.budget.filtered = this.budget.data.filter((el) =>
                el.CategoryName.toLowerCase().includes(text.toLowerCase().trim())
            )
            this.getTotals()
        }
    },
    mixins: [loading],
    mounted() {
        this.getEntities()
        this.getDepartaments()
        this.getCategories()
        this.getYears()
    },
    watch: {
        isLoading(val) {
            if (val) {
                this.openLoading(this.loadingPage)
            } else {
                this.closeLoading(this.loadingPage)
            }
        },
    },
}
</script>

<style scoped>
.vs__dropdown-menu {
    max-height: 50px;
}
</style>